/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetOffersRequest} from '@cash-web/protos/squareup/cash/local/client/app/v1/cash_app_local_client_app_service.pb'
import {GetOffersResponse} from '@cash-web/protos/squareup/cash/local/client/app/v1/cash_app_local_client_app_service.pb'


export const getOffers = (request: GetOffersRequest, options?: CashRequestOptions) => post<GetOffersRequest, GetOffersResponse>("/cash-app/local/offers", request, {...options, rejectOnError: true })